<template>
  <div class="detail-info">
    <div class="title-item">
      <div class="left-label">
        <div class="title-line"></div>
        <div class="title-text">基本信息</div>
      </div>
    </div>
    <div class="content-box">
      <div class="message-item">
        <div class="message-label">赋强业务编号:</div>
        <div class="message-value">
          {{ info.basicInfo.evidenceCode || "-" }}
        </div>
      </div>
      <div class="message-item">
        <div class="message-label">债权人代理:</div>
        <div class="message-value">
          {{ info.basicInfo.creditAgentName || "-" }}
        </div>
      </div>
      <div class="message-item">
        <div class="message-label">公证处:</div>
        <div class="message-value">{{ info.basicInfo.notarial || "-" }}</div>
      </div>
      <div class="message-item">
        <div class="message-label">受理公证员:</div>
        <div class="message-value">
          {{ info.basicInfo.internalNotaryName || "-" }}
        </div>
      </div>
      <div class="message-item">
        <div class="message-label">创建时间:</div>
        <div class="message-value">
          {{ info.basicInfo.signStartTime || "-" }}
        </div>
      </div>
      <div class="message-item">
        <div class="message-label">出证时间:</div>
        <div class="message-value">
          {{ info.basicInfo.certificateDate || "-" }}
        </div>
      </div>
    </div>
    <div class="title-item">
      <div class="left-label">
        <div class="title-line"></div>
        <div class="title-text">合同信息</div>
      </div>
    </div>
    <div class="content-box">
      <div class="message-item">
        <div class="message-label">合同名称:</div>
        <div class="message-value">
          {{ info.basicInfo.contractName || "-" }}
        </div>
      </div>
      <div class="message-item">
        <div class="message-label">合同编号:</div>
        <div class="message-value">{{ info.basicInfo.contractNo || "-" }}</div>
      </div>
      <div class="message-item">
        <div class="message-label">还款金额:</div>
        <div class="message-value">
          {{ info.basicInfo.repayAmount || "-" }} 单位：元
        </div>
      </div>
      <div class="message-item">
        <div class="message-label"></div>
        <div class="message-value">
        
        </div>
      </div>
    </div>

    <div class="title-item">
      <div class="left-label">
        <div class="title-line"></div>
        <div class="title-text">债务人信息</div>
      </div>
    </div>
    <div class="content-box">
      <div class="message-item">
        <div class="message-label">姓名:</div>
        <div class="message-value">{{ info.basicInfo.borrower || "-" }}</div>
      </div>
      <div class="message-item">
        <div class="message-label">身份证号:</div>
        <div class="message-value">{{ info.basicInfo.documentNum || "-" }}</div>
      </div>
      <div class="message-item">
        <div class="message-label">手机号:</div>
        <div class="message-value">{{ info.basicInfo.contactNum || "-" }}</div>
      </div>
      <div class="message-item">
        <div class="message-label">电子邮箱:</div>
        <div class="message-value">
          {{ info.basicInfo.contactMailbox || "-" }}
        </div>
      </div>
      <div class="message-item">
        <div class="message-label">实际联系地址:</div>
        <div class="message-value">
          {{ info.basicInfo.postalAddress || "-" }}
        </div>
      </div>
      <div class="message-item"></div>
      <div class="message-item">
        <div class="message-label">业务办理链接:</div>
        <div class="message-value">
          <div class="border-text">
            {{ info.basicInfo.wxUrlLink || "-" }}
          </div>
          <div>
            <el-button
              size="mini"
              type="danger"
              reset-button
              @click="copyToClipboard(info.basicInfo.wxUrlLink)"
              >复制</el-button
            >
          </div>
        </div>
      </div>
      <div class="message-item">
        <div class="message-label">办理二维码:</div>
        <div class="message-value">
          <div class="qrcode-box">
            <vue-qr
              id="qrcode"
              :text="info.basicInfo.wxUrlLink"
              :callback="qrcodeCallback"
              :size="200"
              :margin="4"
            ></vue-qr>
          </div>
          <div>
            <el-button
              size="mini"
              type="danger"
              reset-button
              @click="copyQrcode"
              >复制</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="title-item">
      <div class="left-label">
        <div class="title-line"></div>
        <div class="title-text">业务信息</div>
      </div>
    </div>
    <div class="content-box">
      <div class="message-item message-item-center">
        <div class="message-label" style="justify-content: flex-start">
          <span class="label-num">1</span>
          完成实名认证:
        </div>
        <div class="message-value">
          <div class="over-time-box">
            <img
              src="../../../../assets/images/business/wc.png"
              class="wc-image"
              alt=""
              v-if="info.basicInfo.handingTimes[1]"
            />
            <span>{{ info.basicInfo.handingTimes[1] || "-" }}</span>
          </div>
        </div>
      </div>
      <div class="message-item message-item-center">
        <div class="message-label">
          <span class="label-num">2</span>
          完成协议确认:
        </div>
        <div class="message-value">
          <div class="over-time-box">
            <img
              src="../../../../assets/images/business/wc.png"
              class="wc-image"
              alt=""
              v-if="info.basicInfo.handingTimes[2]"
            />
            <span>{{ info.basicInfo.handingTimes[2] || "-" }}</span>
          </div>
        </div>
      </div>
      <div class="message-item message-item-center">
        <div class="message-label" style="justify-content: flex-start">
          <span class="label-num">3</span>
          完成公证告知:
        </div>
        <div class="message-value">
          <div class="over-time-box">
            <img
              src="../../../../assets/images/business/wc.png"
              class="wc-image"
              alt=""
              v-if="info.basicInfo.handingTimes[3]"
            />
            <span>{{ info.basicInfo.handingTimes[3] || "-" }}</span>
          </div>
        </div>
      </div>
      <div class="message-item message-item-center">
        <div class="message-label">
          <span class="label-num">4</span>
          完成意愿表达:
        </div>
        <div class="message-value">
          <div class="over-time-box">
            <img
              src="../../../../assets/images/business/wc.png"
              class="wc-image"
              alt=""
              v-if="info.basicInfo.handingTimes[4]"
            />
            <span>{{ info.basicInfo.handingTimes[4] || "-" }}</span>
          </div>
        </div>
      </div>
      <div class="message-item message-item-center">
        <div class="message-label" style="justify-content: flex-start">
          <span class="label-num">5</span>
          完成签署:
        </div>
        <div class="message-value">
          <div class="over-time-box">
            <img
              src="../../../../assets/images/business/wc.png"
              class="wc-image"
              alt=""
              v-if="info.basicInfo.handingTimes[5]"
            />
            <span>{{ info.basicInfo.handingTimes[5] || "-" }}</span>
          </div>
        </div>
      </div>
      <div class="message-item message-item-center">
        <div class="message-label">
          <span class="label-num">6</span>
          完成送达确认:
        </div>
        <div class="message-value">
          <div class="over-time-box">
            <img
              src="../../../../assets/images/business/wc.png"
              class="wc-image"
              alt=""
              v-if="info.basicInfo.handingTimes[6]"
            />
            <span>{{ info.basicInfo.handingTimes[6] || "-" }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="title-item">
      <div class="left-label">
        <div class="title-line"></div>
        <div class="title-text">沟通记录</div>
      </div>
    </div>
    <div class="content-box">
      <div
        class="message-item message-item-center message-item-100"
        v-for="item in info.commNotes"
        :key="item.id"
      >
        <div class="message-label message-label-2">{{ item.createTime }}</div>
        <div class="message-value">
          <div class="over-time-box">
            <span>
              {{ item.note }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
<script>
import Util from "@lib/util.js";
import VueQr from "vue-qr"; //二维码插件

export default {
  name: "",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  components: {
    VueQr,
  },

  data() {
    return {
      qrcodeBase64: "",
    };
  },

  created() {},
  mounted() {},

  methods: {
    copyToClipboard: Util.copyToClipboard,
    qrcodeCallback(data) {
      let ele = document.getElementById("qrcode").firstChild;
      if (ele) {
        ele.style.width = "100%";
        ele.style.height = "100%";
      }
      this.qrcodeBase64 = data;
    },
    // 复制二维码
    copyQrcode() {
      if (!this.qrcodeBase64) {
        this.$message.error("复制失败，请手动复制");
        return;
      }
      Util.copyImgToClipboard(this.qrcodeBase64);
    },
  },
};
</script>
      
<style scoped lang='scss'>
.detail-info {
  padding: 31px 23px;
  .title-item {
    display: flex;
    align-items: center;
    margin-bottom: 17px;
    .left-label {
      display: flex;
      align-items: center;

      .title-line {
        width: 4px;
        height: 19px;
        background: #d81212;
        border-radius: 4px;
      }
      .title-text {
        margin-left: 9px;
        color: #787878;
        font-size: 15px;
        font-weight: bold;
      }
    }
    .right-value {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #787878;
      line-height: 15px;
      font-size: 13px;
      .bj-image {
        width: 15px;
        height: 15px;
        margin-right: 8px;
      }
    }
  }

  .content-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .message-item {
      width: 45%;
      display: flex;
      color: #505050;
      box-sizing: border-box;
      margin-bottom: 24px;
      &:last-child {
        // margin-bottom: 0;
      }
      &.message-item-100 {
        width: 100%;
      }
      &.message-item-center {
        align-items: center;
      }
      &:nth-child(2n-1) {
        // padding-right: 24px;
        .message-label {
          //   width: 170px;
          padding-left: 26px;
        }
      }
      .message-label {
        width: 102px;
        font-weight: bold;
        font-size: 13px;
        margin-right: 10px;
        text-align: right;
        line-height: 16px;
        display: flex;
        justify-content: flex-end;
        &.message-label-2 {
          width: 166px;
          padding-right: 0;
          padding-left: 0;
        }
        .label-num {
          width: 13px;
          height: 13px;
          border: 1px solid #717171;
          color: #717171;
          line-height: 13px;
          font-size: 10px;
          text-align: center;
          display: inline-block;
          border-radius: 50%;
          margin-right: 4px;
        }
      }
      .message-value {
        font-weight: 400;
        line-height: 16px;
        font-size: 11px;
        flex: 1;
        display: flex;

        .border-text {
          width: 161px;
          border: 1px solid #e9e9e9;
          box-sizing: border-box;
          padding: 8px;
          word-break: break-all;
          margin-right: 8px;
        }
        .qrcode-box {
          width: 86px;
          height: 86px;
          border: 1px solid;
          margin-right: 8px;
          overflow: hidden;
          #qrcode {
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .over-time-box {
          display: flex;
          align-items: center;
          .wc-image {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style>
<style>
.reset-button {
  border-radius: 2px;
  padding: 7px 15px;
}

.el-button--danger {
  color: #fff;
  background-color: #db1c1b;
  border-color: #db1c1b;
}
</style>
      